import React, { useEffect, useState } from "react";
import {
  GetRequest,
  PostRequest,
  PutRequest,
  DeleteRequest,
} from "../../repository/RequestMaker";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrashCan, faEdit } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import Modal from "react-modal";
import "./Companies.css";

export default function RiskSubCategories() {
  const [subCategories, setSubCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    risk_category_id: "",
  });
  const [deleteId, setDeleteId] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchSubCategories();
  }, []);

  const fetchSubCategories = () => {
    setLoading(true);
    GetRequest("/risk_sub_categories")
      .then((response) => {
        setSubCategories(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Failed to fetch sub categories", error);
        setLoading(false);
      });
  };

  const openEditModal = (subCategorie = null) => {
    if (subCategorie) {
      setFormData({
        id: subCategorie.id,
        name: subCategorie.name,
        risk_category_id: subCategorie.risk_category_id,
      });
      setIsEditMode(true);
    } else {
      setFormData({
        id: "",
        name: "",
        risk_category_id: "",
      });
      setIsEditMode(false);
    }
    setModalIsOpen(true);
  };

  const closeEditModal = () => {
    setModalIsOpen(false);
  };

  const openDeleteModal = (id) => {
    setDeleteId(id);
    setDeleteModalIsOpen(true);
  };

  const closeDeleteModal = () => {
    setDeleteModalIsOpen(false);
    setDeleteId(null);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const request = isEditMode
      ? PutRequest(formData, `/risk_sub_categories/${formData.id}`)
      : PostRequest(formData, "/risk_sub_categories");

    request
      .then(() => {
        fetchSubCategories();
        closeEditModal();
      })
      .catch((error) => {
        console.error("Failed to submit form", error);
      });
  };

  const handleDelete = () => {
    DeleteRequest(`/risk_sub_categories/${deleteId}`)
      .then(() => {
        fetchSubCategories();
        closeDeleteModal();
      })
      .catch((error) => {
        console.error("Failed to delete sub categorie", error);
        closeDeleteModal();
      });
  };

  const formatDate = (dateString) => {
    return moment(dateString).format("YYYY-MM-DD HH:mm:ss");
  };
  return (
    <div>
      {loading ? (
        <p style={{ textAlign: "center" }}>Wird geladen...</p>
      ) : (
        <div className="card-admin animated fadeInDown">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Erstellungsdatum</th>
                <th>Bearbeitungsdatum</th>
                <th>Aktionen</th>
              </tr>
            </thead>
            <tbody>
              {subCategories.map((subCategorie) => (
                <tr key={subCategorie.id}>
                  <td>{subCategorie.id}</td>
                  <td>{subCategorie.name}</td>
                  <td>{formatDate(subCategorie.created_at)}</td>
                  <td>{formatDate(subCategorie.updated_at)}</td>
                  <td>
                    <button
                      className="btn-edit"
                      onClick={() => openEditModal(subCategorie)}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                    &nbsp;
                    <button
                      className="btn-delete"
                      onClick={() => openDeleteModal(subCategorie.id)}
                    >
                      <FontAwesomeIcon icon={faTrashCan} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeEditModal}
        style={{
          overlay: {
            zIndex: 9999,
          },
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            width: "50%",
            maxHeight: "80%",
            overflow: "auto",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        <h5>
          {isEditMode
            ? "Update Risk Sub Category"
            : "Add New Risk Sub Category"}
        </h5>
        <form onSubmit={handleFormSubmit} className="modal-form">
          <div className="form-group">
            <label>Name:</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
              className="form-control"
            />
          </div>
          <div className="form-group">
            <input
              type="hidden"
              name="company_type_id"
              value={formData.risk_category_id}
              onChange={handleInputChange}
              className="form-control"
            />
          </div>
          <div className="modal-actions">
            <button type="submit" className="btn-submit">
              {isEditMode ? "Update" : "Add"}
            </button>
            <button
              type="button"
              className="btn-cancel"
              onClick={closeEditModal}
            >
              Cancel
            </button>
          </div>
        </form>
      </Modal>
      <Modal
        isOpen={deleteModalIsOpen}
        onRequestClose={closeDeleteModal}
        style={{
          overlay: {
            zIndex: 9999,
          },
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            width: "50%",
            maxHeight: "80%",
            overflow: "auto",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        <h5>Are you sure you want to delete this risk sub category?</h5>
        <div className="modal-actions">
          <button className="btn-delete" onClick={handleDelete}>
            Delete
          </button>
          <button className="btn-cancel" onClick={closeDeleteModal}>
            Cancel
          </button>
        </div>
      </Modal>
    </div>
  );
}
